// import {curriculumPlans, tasks} from '../data'
import { Link, useParams, Outlet, useOutlet, useNavigate, useLocation, useOutletContext } from "react-router-dom"
import { Fragment, useEffect, useState, useContext, useRef, forwardRef } from 'react'
import { Switch, Menu, Transition, Dialog } from '@headlessui/react'
import { DocumentIcon, ArrowDownTrayIcon, VideoCameraIcon, FolderIcon,
    PresentationChartBarIcon, TableCellsIcon, PhotoIcon, GlobeAltIcon,
    ArrowUpRightIcon, ChevronDownIcon, ArrowRightIcon, ArrowLeftIcon,
    ArrowTopRightOnSquareIcon
} from '@heroicons/react/24/solid'
import { XMarkIcon, EllipsisVerticalIcon } from '@heroicons/react/20/solid'
import { DocumentIcon as DocumentOutlineIcon } from '@heroicons/react/24/outline'
import {List} from 'immutable'

import { JsonEditor as Editor } from 'jsoneditor-react'
import 'jsoneditor-react/es/editor.min.css'

import Ajv from 'ajv'
import ace from 'brace'
import 'brace/mode/json'
import 'brace/theme/github'
import 'brace/ext/searchbox'
import 'brace/ext/language_tools'

import Markdown from 'markdown-to-jsx';

import { getDoc, doc, updateDoc, Timestamp } from "firebase/firestore"
import {FirebaseContext} from '../index'
import {schemas as fullSchemas, instructions} from '../data'
import {PageLoading, UserContext} from '../App'
import {classNames} from '../utils'
import api from '../api'
import update from 'immutability-helper'
import { v4 as uuidv4 } from 'uuid'
import { getAuth, getIdToken, getIdTokenResult } from "firebase/auth"
import {DROPBOX_CLIENT_ID} from './login'

import ReactJsonViewCompare from 'react-json-view-compare'
import '../styles/task.sass'

import {Dropbox} from 'dropbox'
import { S3Client, PutObjectCommand, DeleteObjectCommand,
    ListObjectsCommand, CopyObjectCommand } from '@aws-sdk/client-s3'
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers"

import { PDFDocument } from 'pdf-lib'

import SlidesContainer from '../slides-animations/Slides'
import {SlidesEditor} from '../slides'


const WHITE_BG_TAB_BODY_CLASSES = "rounded-b-lg bg-white px-5 py-6 shadow sm:px-6"

/*
var tmpImageThumbnails = [
    {
        ".tag": "success",
        "metadata": {
            "name": "image1.png",
            "path_lower": "/curriculum/engageny/mathematics/grade 5/module 1/math g5-m1 lessons/math-g5-m1-topic-a-lessons/images/math-g5-m1-topic-a-lesson-3/image1.png",
            "path_display": "/Curriculum/EngageNY/Mathematics/Grade 5/Module 1/Math G5-M1 Lessons/Math-G5-M1-Topic-A-Lessons/images/math-g5-m1-topic-a-lesson-3/image1.png",
            "id": "id:JkPLSWSD5a0AAAAAAAAMNg",
            "client_modified": "2023-06-05T03:55:31Z",
            "server_modified": "2023-06-05T03:55:31Z",
            "rev": "5fd59dfbdaf2ebb5f4da1",
            "size": 1617,
            "is_downloadable": true,
            "content_hash": "55324fd2fb1a676c0f57b247cc05cc7b73f89afeb6ddb871bb79c631251fd6da"
        },
        "thumbnail": "iVBORw0KGgoAAAANSUhEUgAAAC8AAABACAIAAAAF57l0AAADnklEQVR4nO2ZyXLiOhSG/yN5ADOEJFQvutJ13/+9SO5QDZjRsizp3IUJzWQblIKw4K+sjGx9PrMVYmbUiQGytvidjozRRFS7+KsKmhaQNvl09nEDlGYaXahxOnLOEIlrowCo20MXapy+O2dvg4IK2zBA2qhJOnLOVjmoKeCaRQRg7+F08qHaqPH03bmi2irU67xIEQK+TESZWqh8ufu2J2yjCzWZjeodRISk9SRlYxLUybpC5Ytd8xzup42azEbWVjpoK2b3BRLGKV+L3Z+1UeP0LJQraWtq2jjo+1D+0OR6NZ39Y6sz6HY0Sq8m6Tszfy8KgCDLl+ns4x5QAATT2QeAe0BBfWe4vR401Tos7QzGWe3wKnF2SBOIUMqwsT8T0TUCf4+G2bXb/X5nWA4VtTc2LvCRd9xcxVP3FcUPmmqdM7wdB+xXJuK6gDuH5vj+azW1BhrnbF6sJckoSj6vcaYW7JfhzEEQRWH7MppyK2vNOB0VRgHodYf9zhCAY57M/ma2HjTMrpM8vzy1q16lwjYMEDI1z4t1ICKGW60nSespkCEAIQJm8rKNq/9QrPVUWfup7FxipxWwXyBz0111NO1WL8sXWq9B1EtepdgsZma/D83GG0/TlFaQIhgOfukiE0KGQVz+JIhenn76JjlLGaHaxw05RUTxn2zaXGvFHS+UZj2qX7WaaY4/bpidLxATCNVjWgPNYjVZq7mUst8ZljWU2f2ejjyrH1w77ve7w8uqHzOIkKn5bPEvCVEYZ6358fIXkWCgMLl3LQ7DomZBnW0Ko0EQJEHC2sI6E8gIgCDh16cYIO8ojqOEVuScYeZW3NlWP8fW2zb+1S+OktfBW5YvpAg6yXPZYgiIogReR0nMHAbRxTRbteJuK+7ug4rh4M0DZe8hFdfvaxJ90FSrIW6sMypfShHEcadMTmbO1LxxUjkpZg6D+KgNN9GU1c9YPZ6OjNUM7iavg94PAAxOF/8xG78MT9rPcZRcOIkCADK1KEwuRchw6yztJc9ShtgchAm/VlV/llAXNyQEgxnMzESe21+k0zTlCyRxv93qAxBC9rvD8hyfgM+5+OI/bhqo6zwlhBwO3gqTCxKljwDQZhL1ETN2XulCmlLbifhTFEfXmkRvXG8a6sKNaRry4L5q8YOmWoc0n7Xy2oWOcKouH2Q4aa3WYn7eAfYXeUhrdfDawf4CyvVS5curo2y2OzTPcfX7zn8O3XcUf6/ui+Z/o7+7IOGQ5NsAAAAASUVORK5CYII="
    },
    {
        ".tag": "success",
        "metadata": {
            "name": "image10.png",
            "path_lower": "/curriculum/engageny/mathematics/grade 5/module 1/math g5-m1 lessons/math-g5-m1-topic-a-lessons/images/math-g5-m1-topic-a-lesson-3/image10.png",
            "path_display": "/Curriculum/EngageNY/Mathematics/Grade 5/Module 1/Math G5-M1 Lessons/Math-G5-M1-Topic-A-Lessons/images/math-g5-m1-topic-a-lesson-3/image10.png",
            "id": "id:JkPLSWSD5a0AAAAAAAAMNw",
            "client_modified": "2023-06-05T03:55:32Z",
            "server_modified": "2023-06-05T03:55:32Z",
            "rev": "5fd59dfd1726cbb5f4da1",
            "size": 22476,
            "is_downloadable": true,
            "content_hash": "d2b025b2f0a47dce4f6251069c3ee0b296e4cdea36b626aa63304c8dc0d4d6e3"
        },
        "thumbnail": "iVBORw0KGgoAAAANSUhEUgAAAEAAAAAkCAIAAAC2bqvFAAAJz0lEQVR4nO1Ye3RUxR3+zdzn7r27ezfZzSYBMYlIApjwMpEEtIfnUVvlYXnUHrEIRUEetmp7Kj7o+7SipVo9RWqr/UNUjhBJgAACXSzJhsBJ0CYRAoaQRJ6b3c3u3eedmf5xa4ohiQJHOZ7D9+fM3JnfN/PN75v7Q4wx+DYDX+sArhbXCVxrXCdwrcH318EYo5Re3IIx7mnhOA4AKKVmEuM4jhLCvjgYIXTxGBMIIYSQOQ9CyJzTHNDzSc/SPS0DAH19aZQx9qXLf5UxA6OPEzAnDQWDvhofxhgQAABCaHxp6ZGGI92hkMVqmTBxoiAIdQcPnj9/XhKlsokTGurrQ8EQz/OUUVVVi0tKBEEAgGNHj7a0tEiiBAhSqVRWVtaNOTm1NT7GWPagQaNGj2pubj7Z2kopHTp0aH5BAQDoul594EAymRw9Zkx2dra5+kB70AuEEMbYobo6TbVlutwZaelO1ZbhTG9sbJw4vtQqSiPy8wOBAGPsnrvutgjikOxBJ1tbJ91+h81izXS5XQ6nJ901bfKU1k8/ZYw9s3q1iLlBnkx3WjoH8IN586oPVNssVgsvLF+6LJlIjC0a5VRtGWnphw8fNuX09saNqmxRJHnV8hWMMcMwLg2yB/3eAZ7nNU0TBMFisSiqCowJgqCqqqZpNrvd3BJFVTVNczgcGGNVVR0Oh8PhkCQpGo3W1vh+/9vfrf/bBkmSNU2z2+02uz3T4/F4PBzHaZqWSCQyszLffOONU22nZItl+cqVY8eONQyD5/mK97c6HA6r1brf6w0Gg5qmDaC0gS4xYywSiZRNnLBo8WKn03nDDTdEo1FGKSXEHEMpJYQQQgCAAUSj0REjRrz1ztsz77k3GAweO3oUADBGjLGorq9YtWrkLSPzCwqOtxwnBpEl6fChw591dgqikJ2dvWz5o5RSnufbTp48WFvL8zxjrKOjY9+evbPum00J4fi+Qx0ojVJKFUWprfHNnX3fxrc2yrJMPg+95wQvJiyK4tmzZ5cuebirqyuZTBYMLwAAQgilVLZYXlq3bv6cuac/O221WgzDkC2Whvp6v9/PGHvq6ac1TUulUgBQtaOqvb29tKx0wsSJsWi0sqICABDuN84v8QGEkGEY4XA4Fov9/xuMRVFECPGCYHJgjAFjHMeFQiGv1xuNRnNycp5d88uLjz4Wi4XDYcMwenIlYwxjDAC8wAOAuevbKitlWZYkSRAFRVVrqqs7OzsvzuCXQQBjrOt6aVnZlq1bFz60MJlIYIx5QQgGgqfa2vSI/llHhyRJ5tqAUDKZHDR4cEFBAaU0EAh8/NFHZsrHGMfj8Z8+8fjm8vKc3Bw9onMcRwjxeDwYY0EQfvncmi5/F8b4oyNHGurr3W731vKtm955V9O0c+fOVW3fbsrh8giYLqMoSnNT0yt/eXnRjxbu3rX79u/cEQgEKKUP3P/Du6ZP7+zsjMfjuXl5GR6PmbuysrKeXbPGMAwA+PmTTyYSCZtqQwBWq7V885YXX1i7aOHC9vZ2m92m6/r0O++86+67U6nUmdOnX3xhLUJoW2VlIh6XZfm793zv3pkzJEmSZblqRxV8bp19YIA0qohSms1us1gdVgUA/vrqq11+/x1lExxWxaGoDkVNd2hji0Y11NenUqlxo0ZjgHGjRjPGVix7VMIcAnh48Y+feWo1ALidaTbZwgFkezwb1r/m0pwIYPnSZe3t7Zkut6aoNou14v2tE8aPB4D75803I3lkyRIR4TS741DdoZ7AeqEPJzaFe+HCBe++f8myzBiN6HosFiu57baRI0cCwK6dOw/VHYqEwzcPGzZj1sy0tDQA+HD//pOtJ+1224xZswCgfPMWU9kZGRlnTp8hlAADQRRkWc676abqAwcwxoWFhYVFRdUHqjs7OgRREAUxHAlHwpHikuJbCgsB4NjRozXVNQAwvrR0+Ijhphp7K6XPp4TJ4UhDw6m2UxarZeq0aT1dVTt2xGKx/Pz8ESNHmi1nzpzZu2ePoihTpk5VVbXuYN3xlmMut9tMWZRQymheXp4gip80N5uO7nK5Ojs6a32+eDxWXFISCnUTw7jp5qEul6s/SfeLPu2NUkopnTppsswLIub+8frfzXz/7w8/dNrsAqDZM2YahhHVdUrp83/4o8zxAqCfPf6EYRgrlj0KAE6b3ananTZ7ut1hquKxFSsRgMwL2yoqE4nEb371ax6QRRBfXLv2n2++OX/O3Pc2bTIMIx6P90iFEJJKpVKplOnQX9WJze2nlCKEsrKyAGDD+vVz5s1VFOXPf1qnKIrD4aCUchwnWyyEkJ1VVZlZWRzH7fd6AeDGnJzC4SMsVmugqwsAbDZbdiqVm5uLMc50ZwiCkJaWJoqi2+12u90Y4/R09wMLFjywYIG5+sWXFWN8qWZ6od/uaDQaCgYJIZIsNzU2VVZUHGlo2Ld3r6qqhmEEuroSiQRC6PChw02NjRhzCKHW1tb9Xu+KVSt9dQdX/eSxcDjc3d09677ZNQdrn1nzXDQaJYQgAJ/Pt2/v3ubmZoxxKpWilACA6WJXgH6fEnokous6x3GGYaiq8vprGzSnUxAEc+/D4XAkEpEkqbJiq9/vf2jRolAoVL55y/tbyidNniyKoizJ8Lk9K6oKAAwYo1SS5Reef54QIgiCzWY7f/68udwVP6r7f053d8diMYwxxkiS5ZaWFsaYoiimP+i6nkwkksnk7l277XZ7PB5PJpM2u83r9Z4/d87ldhNi9MzWK09wHGdqo8/8cbnoQ0LmvKFgMJVKJZPJSZMm2x0OjDCldMiQIbcWF8fj8VgsZhik1uf79PhxTdM2vfvurp07NU3raG/f88Ee+KJxmn9hAGBa8i9Wr36vfMu8+fPD4XC/9nQ1BEwEg0EASCQS06ZPnzV7dkSPxGKxJUsfKSwqIobBKA2FQju2b6eU2h2ORYsXL3jwQVEUBZ7fvm0bQghjzkTPLcQYczwPwIqKim4tLs7NyzOfn1f5R9bvCXR2dF64cCHc3S3J0tJlSykhgwcP/v6cOYSQYDAU0fU9H+yu2r7D3x2aMmXKupdfevnVVwqLigLB4K6qqrNnz/IC7/f7A4FAzyswquuBQCAUCIZCIUpoKBQKBoOBQCCRSFwNgX6d+MSJE40f/wdhVFxSkpmZud/rtdvto8eMaTnW0tTUKAqiy+3y+/2JeGLsuHHZg7IB4MTx4580f8KAlZaVMcp8vhoEaFj+sILhwwHgSENDW1sbRqjktvEZnoyWYy3NTU2AoKioKCc3d4BflssmcCmuePZvAF9eVjFrG4SQXlUQhP5H/tIKiqn7i2snvXpNo+z1+ZXhayyrfDP41lfmrhO41rhO4Frjvzy3kjWF7fZmAAAAAElFTkSuQmCC"
    },
    {
        ".tag": "success",
        "metadata": {
            "name": "image11.jpg",
            "path_lower": "/curriculum/engageny/mathematics/grade 5/module 1/math g5-m1 lessons/math-g5-m1-topic-a-lessons/images/math-g5-m1-topic-a-lesson-3/image11.jpg",
            "path_display": "/Curriculum/EngageNY/Mathematics/Grade 5/Module 1/Math G5-M1 Lessons/Math-G5-M1-Topic-A-Lessons/images/math-g5-m1-topic-a-lesson-3/image11.jpg",
            "id": "id:JkPLSWSD5a0AAAAAAAAMOA",
            "client_modified": "2023-06-05T03:55:33Z",
            "server_modified": "2023-06-05T03:55:33Z",
            "rev": "5fd59dfde74a8bb5f4da1",
            "size": 19500,
            "is_downloadable": true,
            "content_hash": "0e98aa5240eeeb51a0271b2c7f5373991aad2b2fba98b9e8d95134c259882206"
        },
        "thumbnail": "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"
    },
    {
        ".tag": "success",
        "metadata": {
            "name": "image12.jpeg",
            "path_lower": "/curriculum/engageny/mathematics/grade 5/module 1/math g5-m1 lessons/math-g5-m1-topic-a-lessons/images/math-g5-m1-topic-a-lesson-3/image12.jpeg",
            "path_display": "/Curriculum/EngageNY/Mathematics/Grade 5/Module 1/Math G5-M1 Lessons/Math-G5-M1-Topic-A-Lessons/images/math-g5-m1-topic-a-lesson-3/image12.jpeg",
            "id": "id:JkPLSWSD5a0AAAAAAAAMOQ",
            "client_modified": "2023-06-05T03:55:33Z",
            "server_modified": "2023-06-05T03:55:34Z",
            "rev": "5fd59dfea9e79bb5f4da1",
            "size": 19500,
            "is_downloadable": true,
            "content_hash": "0e98aa5240eeeb51a0271b2c7f5373991aad2b2fba98b9e8d95134c259882206"
        },
        "thumbnail": "iVBORw0KGgoAAAANSUhEUgAAAEAAAAAPCAIAAADbBV4wAAAAEGVYSWZJSSoACAAAAAAAAAAAAAAAnDy5KAAAB65JREFUeJylVWlUVOcZfr/vm7l3mGGQYd8HoRYFFbQ0GAFXXErcMMGija2NSdTExFOb1ramqR6OJqZaq+2xNUuTnCZWUz1oxSWxcTfUyOZCFQMCs8g2M6yz3Lnf0h83EO0Se8zz6znfOfe97/Muz4ucdgdCwDiPjIxkjCkBBUCEGI2ywRAMBhFCACA4V1UVBISFj4D7UXulurenl3MWFR09LiebENL8eVNLczMIMIeZ8/InA0AwGOzs6EhOSQEAIQRCyOlwWCwRRpOx4257aJjZZDJp0ZRAwO12JyYlAUB3V9f1unouhCRJefmTZVl2u1yKoiQkJjLGCCG3b96KiIrEzy7/4arvr3yyZMnlT6uOVxzZUb51++atF0+f9bhcdVWfNdTU3aiuu1FT11BT33SzkXOu/UkIwRjbsXVbXXXNqIxRyVbrlX9cZpSdqDz2/jvvJaekZI4be6ep+bXN5VSlVKXlG19xu1xCCADw+/1bfrnZ43YDwJFDFfve/TNCiFKKEPrwg/0VHx4CgLrqmh1bXguPiMgaP04JKJt+trG3p6e/r3/NiqcdNhshRAhRdfGSrbUNDwwMDgx6BwYGqUqDQdXv8/l9PlVVBRdUValKqaoyyhBCgjHGGAAwxhBC5z4503Dt+so1q5Kt1owxo595fs3g4MA7e998/kcvZmSOSUhKXPqD5U6789SJk7Is9/f2HXh/H0IIIXTp3Pl2p8Mf8AOAJOlPHK10u1yEkL6+vqqLFwN+HwDs2r5z/uKSid/OjU9ImFU8Ny4+/r03/2SJsKSlp29Y91JbSytCKNwSHhoainVD0KJjQjAh2uSg+0EZVYPq8PA03LgxZmwWY0xVVUopY6zpdlP4CEtUdDTnnKoqY2x01pjmpmZbW+uzLzx3o/6aw2Z3u1x+v39yYaHDZgeAuIT4eYsWvvG7PRjjc5+cnrdood/r8/l8AZ9vdFYmZ4yqKqN0/IRsu83udrmfWPbdp1Y/s3blqs6OznCLRQBgMQQYGg4Y5gCaDI1wLqiqAgAIAIDExCRbaxshRK/X63Q6QkhsfFxfXy9jDGNMdDpCiMNmH/mN9HZne7LVurisdM9vd58+9feCqVPMI8I8LpcQoqujc/nKFbbWtoN/OWAymSYV5Hd2dev1ekJ0HrcbEwIIEZ3O1maLjY01GAwdd9tnzpm1et3aDevWNzXeNhqNGL4SQghCCCHky1UGQBgJIWYXz1HVYMWBg36/f6B/4MKZs/HxcXmTH92zc/fg4KCqqudPn/X7/EWzi+pravxeb9HcObaWVk+32xIRwbmwtdo6Ozq6u7skSVrweMm7e98qnDZVlqUOZztV1dJlZW/t2evq6uaMNf7z5pWqqmUrlvd4PD0eD+f8sYXzlz+14sAH+4mO6B4oQKfTcRCMMRBCVZThnoSazdt27zzy10NHKw5LeinUbCY63fqf//TY4b99fOy4Xi8pirJ521bZYMjIyoxNiBdCbCzfFBEVJYSYXJjf4/YIIR4tKBRCTJk5PSE5SZJlQGjJk2Ver3dR6eKY2JjTH58ymox+n3/DKy8nJicxxsZPyMEYU0pnzpkVajYTTND0RwowIf29va/+5vUO593ay58JLooem5s7Ka/xeoNepzeFhQKAt3+Qc5Y40mpNT9OsUHCO8P9soOZ0MOSbX12m/1q4Lxz8P4gGzjnGGAAe1AEQGGPNtgAQHVpiIQTC2NXtOll5LMxsDqqqogSeWFomy/LRisNKICDLhh6PZ1rRjJTU1IZr1y+eO5+SanXaHQsWl0RFR739xzfCwsIAoGDa1MTkJM2dtYQ445hghBDnXDOPYSKEACG0qmGMNQ0P2AEAQAjrZVmAQAiCSnD4va+39+Uf/yTFmlK8aMG8RQsTk5Ixwrte336nqbl4wfziBfMm5H6rfOOvPG5P+927n99qnF38nUAg8PuduzAhly5cKpwxrWRJaUxcrJbNcCaYDBGMtZIPE4TQvT3XPnmQAAEIgSRLIARCKKiqWvsQQh9Vngg1m6fMmE4IMYQYphXNcLtcn56/tPrFtUaTCRAal5OdNmpU5eEj0dExOp3e7/NhhMdljwcAs9nstDucDru43/EeAngY/+b6mmJACAAkSQaEEMacUe2KAUBXV1dMXBznnFKq3QGXyxViMsqyzDnnnDPGoqOje9weTHB/f99LL6xLTRtZuqwsGAxyzu02+52m5qCiAMDXkYG9Xq/P6/UOeimlqqoqAUUJKJRSIQSllDPKGNdJesYYozTg81NV1QTkTJxwtbYOYzx8B6yp1oDP33qnRXskhNTX1eZOyvN6valpI59es/rgvv0+r48QIklSSenjM+fMDjWb4Z5T8xDQZedkI4y9gwPhERYaDKampwkhLBERkiSFhY8gRBdiMsoG2RIVKUmSXtIj/MWG5U+dUnul+tflW4sXzuecX796rXRZ2XPr1739h71Lvrd0RHj4hTPnRmV8M39KwUfHjnd3dufmPZKdO3HTLzZufnVLX2/PycrjISEhmWOzYuJiH86pNKB72zfM//9wV2vruzraZUNIalpqstWKEHLaHbdvNQKCyMjI8RNyAMDtcvf2eEampwNA7ZXqjMwxbS0tPq+PqjQjc3RkVNTXEfAv6FkQFcVKknwAAAAASUVORK5CYII="
    },
    {
        ".tag": "success",
        "metadata": {
            "name": "image2.jpeg",
            "path_lower": "/curriculum/engageny/mathematics/grade 5/module 1/math g5-m1 lessons/math-g5-m1-topic-a-lessons/images/math-g5-m1-topic-a-lesson-3/image2.jpeg",
            "path_display": "/Curriculum/EngageNY/Mathematics/Grade 5/Module 1/Math G5-M1 Lessons/Math-G5-M1-Topic-A-Lessons/images/math-g5-m1-topic-a-lesson-3/image2.jpeg",
            "id": "id:JkPLSWSD5a0AAAAAAAAMOg",
            "client_modified": "2023-06-05T03:55:36Z",
            "server_modified": "2023-06-05T03:55:37Z",
            "rev": "5fd59e01811b6bb5f4da1",
            "size": 462065,
            "is_downloadable": true,
            "content_hash": "80fe21971fe4497bc8e352de48150f21fab5fc6b935a0864354328da2d01b390"
        },
        "thumbnail": "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"
    },
    {
        ".tag": "success",
        "metadata": {
            "name": "image3.jpg",
            "path_lower": "/curriculum/engageny/mathematics/grade 5/module 1/math g5-m1 lessons/math-g5-m1-topic-a-lessons/images/math-g5-m1-topic-a-lesson-3/image3.jpg",
            "path_display": "/Curriculum/EngageNY/Mathematics/Grade 5/Module 1/Math G5-M1 Lessons/Math-G5-M1-Topic-A-Lessons/images/math-g5-m1-topic-a-lesson-3/image3.jpg",
            "id": "id:JkPLSWSD5a0AAAAAAAAMOw",
            "client_modified": "2023-06-05T03:55:37Z",
            "server_modified": "2023-06-05T03:55:38Z",
            "rev": "5fd59e0271b76bb5f4da1",
            "size": 164721,
            "is_downloadable": true,
            "content_hash": "de6b24872d3fbce302683053f69c8ff1f8bc9d0db1fd9229b0bd161b41584823"
        },
        "thumbnail": "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"
    },
    {
        ".tag": "success",
        "metadata": {
            "name": "image4.jpg",
            "path_lower": "/curriculum/engageny/mathematics/grade 5/module 1/math g5-m1 lessons/math-g5-m1-topic-a-lessons/images/math-g5-m1-topic-a-lesson-3/image4.jpg",
            "path_display": "/Curriculum/EngageNY/Mathematics/Grade 5/Module 1/Math G5-M1 Lessons/Math-G5-M1-Topic-A-Lessons/images/math-g5-m1-topic-a-lesson-3/image4.jpg",
            "id": "id:JkPLSWSD5a0AAAAAAAAMPA",
            "client_modified": "2023-06-05T03:55:39Z",
            "server_modified": "2023-06-05T03:55:39Z",
            "rev": "5fd59e0417f99bb5f4da1",
            "size": 200697,
            "is_downloadable": true,
            "content_hash": "e4ca5a90c2d7671d6712d3080bc857d31b573691357c3b305f33ea0827457a7d"
        },
        "thumbnail": "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"
    },
    {
        ".tag": "success",
        "metadata": {
            "name": "image5.jpeg",
            "path_lower": "/curriculum/engageny/mathematics/grade 5/module 1/math g5-m1 lessons/math-g5-m1-topic-a-lessons/images/math-g5-m1-topic-a-lesson-3/image5.jpeg",
            "path_display": "/Curriculum/EngageNY/Mathematics/Grade 5/Module 1/Math G5-M1 Lessons/Math-G5-M1-Topic-A-Lessons/images/math-g5-m1-topic-a-lesson-3/image5.jpeg",
            "id": "id:JkPLSWSD5a0AAAAAAAAMPQ",
            "client_modified": "2023-06-05T03:55:40Z",
            "server_modified": "2023-06-05T03:55:40Z",
            "rev": "5fd59e04fb8efbb5f4da1",
            "size": 57746,
            "is_downloadable": true,
            "content_hash": "58ce0163eb10c6f8c681c938e166a5c17c7e1536c5eba590d50b3bafdea459ee"
        },
        "thumbnail": "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"
    },
    {
        ".tag": "success",
        "metadata": {
            "name": "image6.png",
            "path_lower": "/curriculum/engageny/mathematics/grade 5/module 1/math g5-m1 lessons/math-g5-m1-topic-a-lessons/images/math-g5-m1-topic-a-lesson-3/image6.png",
            "path_display": "/Curriculum/EngageNY/Mathematics/Grade 5/Module 1/Math G5-M1 Lessons/Math-G5-M1-Topic-A-Lessons/images/math-g5-m1-topic-a-lesson-3/image6.png",
            "id": "id:JkPLSWSD5a0AAAAAAAAMPg",
            "client_modified": "2023-06-05T03:55:41Z",
            "server_modified": "2023-06-05T03:55:41Z",
            "rev": "5fd59e05e636fbb5f4da1",
            "size": 5724,
            "is_downloadable": true,
            "content_hash": "e13b1b6ab43565558b20ea1e9f06a7e53a1b18507f15e8a89b33dfcbe834ecf2"
        },
        "thumbnail": "iVBORw0KGgoAAAANSUhEUgAAAEAAAAAMCAIAAABdkSyeAAAFh0lEQVR4nM1WW0xTWRTd53EvfVMoFbQwQsJAqw6SNEYx6aiIjNdULUkN+Io00Y+ZZIxNHUwM/YNfoxGc4CMRQR1jHMAX8tAIScnUxxijMZFoB4boiBSN0guX3vae+bhjYwbjpzPr5+yc7LPPPjt77XVQZmZmSUkJJZQBY4wRTIwm48zMTCwWgw/QarVGozEWi8lxGWGEMdbr9Ywx+E8hiuKDBw9oyTclZ9rOjI6NUkoppZIkXb9y/auFX210bzSZTIwxaVYaHBgMh8PlFeXZOdmyLIux2J3f7hJCAABjjBBijDHGEEIAoCgKQgghpCiK6qBupgyEUMr+uAqpUP86ODd1hFAymaysrKyrq6Mcx72Ovh7+46lWo+Uot3/fT1mZWW1tbdnZ2WoeOp3O5XJ1dXVVeaqOnWjW63UM4OSpE8+fRb5AmT8DnU5nNBoxY4wQwlPemmXt+rWLJVg4HHY4HJRSQgjGmFKanZ3d1ta2+tvVx48dN5szDHrD9z/+wPM8pdRutwuCIAiCwWBYtmyZ3W4HgPnz55eXl6sOJSUlTqcTABwOx+LFizHGHMetX7++pqYmNzeXUspxHKUUANasWePz+ZxOJyGEEGK328vKyjDGZA54nieEpKWlKYqCAQAYQwjNzMxcv3q9oaGBEFJfXy8IQlNT05MnTzwej9vtfvTo0eEjRx4+ePjqr1eyLOcXLMzNy00kEkePHm1sbNy2bdvg4KDL5QqHwwUFBf39/V6vNx6PJxKJxsbGe/fuZWRkBAIBNfjg4GAwGNywYcPWrVsTHxAMBpubm4uLi7dv36622ZUrV4aGhhwOh9ppyTlQ248CAAOgHJ14PSHHE8IGoaOjo729/dq1a1NTUzt37qypqXG5XHq9Pj8/35KZNTY2ttSyFCFky7VFnkdkWRZFMZlMGo3GQ4cOlZaW3rlzZ3h4uK6ubt68eW/evJmeno5GowcPHpRleWJiYtOmTaWlpTqdTuWMRqMxmUzv3783m80Wi2V8fPzq1auMsc2bN09OToZCoX379u3Zs4cQ8kkyAABWFwSIAQMAjHE8HgcAk8mEMZYkSavV6vX6ZDKp+jHlH9qplMUYi6J4+/btjIyMoqKivXv3ZmVl+f3+3bt337x50+l08jx/+vRpi8Xi8Xii0WhaWlqqeIwxr9fb19e3a9eu/fv319bWrlix4vHjxwaDYceOHVqtNh6PV1dXazSaRCKhXvfpByAAOSFbrVZCSV9v35YtW9xut8/nC4VCra2tly9fDgQCoiiOjIxMTk7a8myJRCIej7988RIAeJ632WyLFi1SM1PrxPN8S0vL2rVr79+/n5OTI8tyQ0NDTk6O1Wrt7OyMRCK3bt1qaWnx+/0XL16sqKhobW09cOCAIAhTU1MvXrwoLi6urKzs6ekZGRlRFMXn8wGAOvTmggIAwpgpTKfTfSdU1tfXV9dUNzU1pTx6e3tVo8pT5Vhst9lssiw/f/Z87M8xjuMCgUBhYSHHcUuWLBkdHTUYDIIgPH36VJIkSZIwxn6/PxaLRSKRdevWvX37VpKklStXut1us9nc398vy3I0GkUIXbhwoby8XKPRBINBRVG8Xm93dzcA9PT0qIMEIaRyXX2MOiEBACrWVtz9/e7JthNnL7b/0nF+Qe6CspVlw8PD8kcYHx+vra0lFP986tj5S+fOXTr7dVHhZ0fcl8Dhw4c9Hg9VmJJnywMElFBKSUdnR+elzoGBAes8a3p6OlPY7Ozs0NCQxWLpvnEjN88Wj8vv3r3bvm3Hx0IGACkBUgmXUqiUHhFCVJ9PCpm6qSqUeiplwBw5wxjLsrxq1aru7m6Unp6+fPlyQggwYIxhgk0m0/T0tCiKqejqV2JanJ6dncUYY4z1hv/FVyIUCv0N9Oy7R/pp1fcAAAAASUVORK5CYII="
    },
    {
        ".tag": "success",
        "metadata": {
            "name": "image7.png",
            "path_lower": "/curriculum/engageny/mathematics/grade 5/module 1/math g5-m1 lessons/math-g5-m1-topic-a-lessons/images/math-g5-m1-topic-a-lesson-3/image7.png",
            "path_display": "/Curriculum/EngageNY/Mathematics/Grade 5/Module 1/Math G5-M1 Lessons/Math-G5-M1-Topic-A-Lessons/images/math-g5-m1-topic-a-lesson-3/image7.png",
            "id": "id:JkPLSWSD5a0AAAAAAAAMPw",
            "client_modified": "2023-06-05T03:55:42Z",
            "server_modified": "2023-06-05T03:55:42Z",
            "rev": "5fd59e06f5cd9bb5f4da1",
            "size": 22476,
            "is_downloadable": true,
            "content_hash": "d2b025b2f0a47dce4f6251069c3ee0b296e4cdea36b626aa63304c8dc0d4d6e3"
        },
        "thumbnail": "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"
    },
    {
        ".tag": "success",
        "metadata": {
            "name": "image8.jpeg",
            "path_lower": "/curriculum/engageny/mathematics/grade 5/module 1/math g5-m1 lessons/math-g5-m1-topic-a-lessons/images/math-g5-m1-topic-a-lesson-3/image8.jpeg",
            "path_display": "/Curriculum/EngageNY/Mathematics/Grade 5/Module 1/Math G5-M1 Lessons/Math-G5-M1-Topic-A-Lessons/images/math-g5-m1-topic-a-lesson-3/image8.jpeg",
            "id": "id:JkPLSWSD5a0AAAAAAAAMQA",
            "client_modified": "2023-06-05T03:55:43Z",
            "server_modified": "2023-06-05T03:55:43Z",
            "rev": "5fd59e07d8ba5bb5f4da1",
            "size": 57746,
            "is_downloadable": true,
            "content_hash": "58ce0163eb10c6f8c681c938e166a5c17c7e1536c5eba590d50b3bafdea459ee"
        },
        "thumbnail": "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"
    },
    {
        ".tag": "success",
        "metadata": {
            "name": "image9.png",
            "path_lower": "/curriculum/engageny/mathematics/grade 5/module 1/math g5-m1 lessons/math-g5-m1-topic-a-lessons/images/math-g5-m1-topic-a-lesson-3/image9.png",
            "path_display": "/Curriculum/EngageNY/Mathematics/Grade 5/Module 1/Math G5-M1 Lessons/Math-G5-M1-Topic-A-Lessons/images/math-g5-m1-topic-a-lesson-3/image9.png",
            "id": "id:JkPLSWSD5a0AAAAAAAAMQQ",
            "client_modified": "2023-06-05T03:55:44Z",
            "server_modified": "2023-06-05T03:55:44Z",
            "rev": "5fd59e08aa617bb5f4da1",
            "size": 5724,
            "is_downloadable": true,
            "content_hash": "e13b1b6ab43565558b20ea1e9f06a7e53a1b18507f15e8a89b33dfcbe834ecf2"
        },
        "thumbnail": "iVBORw0KGgoAAAANSUhEUgAAAEAAAAAMCAIAAABdkSyeAAAFh0lEQVR4nM1WW0xTWRTd53EvfVMoFbQwQsJAqw6SNEYx6aiIjNdULUkN+Io00Y+ZZIxNHUwM/YNfoxGc4CMRQR1jHMAX8tAIScnUxxijMZFoB4boiBSN0guX3vae+bhjYwbjpzPr5+yc7LPPPjt77XVQZmZmSUkJJZQBY4wRTIwm48zMTCwWgw/QarVGozEWi8lxGWGEMdbr9Ywx+E8hiuKDBw9oyTclZ9rOjI6NUkoppZIkXb9y/auFX210bzSZTIwxaVYaHBgMh8PlFeXZOdmyLIux2J3f7hJCAABjjBBijDHGEEIAoCgKQgghpCiK6qBupgyEUMr+uAqpUP86ODd1hFAymaysrKyrq6Mcx72Ovh7+46lWo+Uot3/fT1mZWW1tbdnZ2WoeOp3O5XJ1dXVVeaqOnWjW63UM4OSpE8+fRb5AmT8DnU5nNBoxY4wQwlPemmXt+rWLJVg4HHY4HJRSQgjGmFKanZ3d1ta2+tvVx48dN5szDHrD9z/+wPM8pdRutwuCIAiCwWBYtmyZ3W4HgPnz55eXl6sOJSUlTqcTABwOx+LFizHGHMetX7++pqYmNzeXUspxHKUUANasWePz+ZxOJyGEEGK328vKyjDGZA54nieEpKWlKYqCAQAYQwjNzMxcv3q9oaGBEFJfXy8IQlNT05MnTzwej9vtfvTo0eEjRx4+ePjqr1eyLOcXLMzNy00kEkePHm1sbNy2bdvg4KDL5QqHwwUFBf39/V6vNx6PJxKJxsbGe/fuZWRkBAIBNfjg4GAwGNywYcPWrVsTHxAMBpubm4uLi7dv36622ZUrV4aGhhwOh9ppyTlQ248CAAOgHJ14PSHHE8IGoaOjo729/dq1a1NTUzt37qypqXG5XHq9Pj8/35KZNTY2ttSyFCFky7VFnkdkWRZFMZlMGo3GQ4cOlZaW3rlzZ3h4uK6ubt68eW/evJmeno5GowcPHpRleWJiYtOmTaWlpTqdTuWMRqMxmUzv3783m80Wi2V8fPzq1auMsc2bN09OToZCoX379u3Zs4cQ8kkyAABWFwSIAQMAjHE8HgcAk8mEMZYkSavV6vX6ZDKp+jHlH9qplMUYi6J4+/btjIyMoqKivXv3ZmVl+f3+3bt337x50+l08jx/+vRpi8Xi8Xii0WhaWlqqeIwxr9fb19e3a9eu/fv319bWrlix4vHjxwaDYceOHVqtNh6PV1dXazSaRCKhXvfpByAAOSFbrVZCSV9v35YtW9xut8/nC4VCra2tly9fDgQCoiiOjIxMTk7a8myJRCIej7988RIAeJ632WyLFi1SM1PrxPN8S0vL2rVr79+/n5OTI8tyQ0NDTk6O1Wrt7OyMRCK3bt1qaWnx+/0XL16sqKhobW09cOCAIAhTU1MvXrwoLi6urKzs6ekZGRlRFMXn8wGAOvTmggIAwpgpTKfTfSdU1tfXV9dUNzU1pTx6e3tVo8pT5Vhst9lssiw/f/Z87M8xjuMCgUBhYSHHcUuWLBkdHTUYDIIgPH36VJIkSZIwxn6/PxaLRSKRdevWvX37VpKklStXut1us9nc398vy3I0GkUIXbhwoby8XKPRBINBRVG8Xm93dzcA9PT0qIMEIaRyXX2MOiEBACrWVtz9/e7JthNnL7b/0nF+Qe6CspVlw8PD8kcYHx+vra0lFP986tj5S+fOXTr7dVHhZ0fcl8Dhw4c9Hg9VmJJnywMElFBKSUdnR+elzoGBAes8a3p6OlPY7Ozs0NCQxWLpvnEjN88Wj8vv3r3bvm3Hx0IGACkBUgmXUqiUHhFCVJ9PCpm6qSqUeiplwBw5wxjLsrxq1aru7m6Unp6+fPlyQggwYIxhgk0m0/T0tCiKqejqV2JanJ6dncUYY4z1hv/FVyIUCv0N9Oy7R/pp1fcAAAAASUVORK5CYII="
    }
]
*/

export default function TaskPage(){
    const params = useParams()
    var outlet = useOutlet()
    let location = useLocation()
    let navigate = useNavigate()
    const [saving, setSaving] = useState()
    const [user, setUser] = useContext(UserContext);

    const [task, setTask] = useState()
    // task = tasks.find(t => t.id === params.taskID)

    useEffect(() => {
        if (task){
            document.title = `${task.title} · ${task.parentTitle}`
        }
    }, [task])

    const [status, setStatus] = useState()

    const [app, db] = useContext(FirebaseContext)

    var subpage = location.pathname.split('/')[4]

    const tabs = [
      { name: 'Instructions', href: 'instructions', current: subpage === 'instructions' },
      { name: 'Materials', href: 'materials', current: subpage === 'materials' },
      { name: 'Work', href: 'work', current: subpage === 'work' },
      { name: 'Comments', href: 'comments', current: subpage === 'comments' },
    ]

    const isAssignee = task && (user.email === task.assignee.id)

    var showReviewTab, canBeReviewed = task && (task.status === 'review' && user.email === task.assigner.id)
    if (task && (['reviewed', 'complete'].indexOf(task.status) !== -1 || canBeReviewed))
        showReviewTab = true

    if (showReviewTab)
        tabs.push({ name: 'Review', href: 'review', current: subpage === 'review' })


    const currentTab = tabs.find((tab) => tab.current)

    useEffect(() => {
        if (!outlet){
            navigate('instructions', { replace: true })
        }
    }, [location])

    useEffect(() => {
        api.getTask(db, params.taskID).then((taskData) => {
            setStatus(taskData.status)
            setTask(taskData)
        })
    }, [])

    if (!task)
        return <PageLoading />

    var statuses = {
        'assigned': {
            title: 'Assigned',
            classes: 'bg-blue-100 text-blue-800',
            action: {
                disabled: false,
                onClick: () => {
                    api.updateTaskStatus(db, params.taskID, 'review').then(() => {
                        setStatus('review')
                    })
                },
                title: 'Submit for review'
            }
        },
        'review': {
            title: 'Submitted for review',
            classes: 'bg-yellow-100 text-yellow-800'
        },
        'reviewed': {
            title: 'Reviewed',
            classes: 'bg-red-100 text-red-800',
            action: {
                disabled: false,
                title: 'Accept suggestions',
                onClick: () => {
                    api.mergeReviewIntoTask(db, task).then(() => {
                        api.updateTaskStatus(db, params.taskID, 'complete').then(() => {
                            navigate('/app/tasks/approved')
                            setStatus('complete')
                        })
                    })
                }
            },
        },
        'complete': {
            title: 'Approved',
            classes: 'bg-green-100 text-green-800'
        }
    }

    return <div>

    <header className="pt-6">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

        <div className="relative border-b border-gray-200 pb-5 sm:pb-0">
          <h3 className="text-lg font-medium leading-6 text-gray-900">
              Task: {task.title}
              <span className={classNames("ml-2 inline-flex items-center rounded-md px-2.5 py-0.5 text-sm font-medium", statuses[task.status].classes)}>
                {statuses[task.status].title}
              </span>
          </h3>
          <div className="mt-1 text-sm text-gray-500">
              {task.parentTitle}
          </div>

          <div className="mt-3 flex md:absolute md:top-3 md:right-0 md:mt-0">
              <button
                type="button"
                className={classNames("inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2", saving ? 'opacity-50' : 'hover:bg-gray-50')}
                disabled={saving}
              >
                {saving ? 'Saving...' : 'Saved'}
            </button>
              {isAssignee && statuses[status].action ? <button
                type="button"
                onClick={statuses[status].action.onClick}
                className="ml-3 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                {statuses[status].action.title}
              </button> : null}
              {canBeReviewed ? <div className="ml-3 inline-flex rounded-md shadow-sm">
                  <button
                    type="button"
                    onClick={() => {
                        api.updateTaskStatus(db, params.taskID, 'complete').then(() => {
                            setStatus('complete')
                        })
                    }}

                    className="p-1 border-r-indigo-400 rounded-l-md relative inline-flex items-center border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    Approve
                  </button>
                  <Menu as="div" className="relative block">
                    <Menu.Button className="h-full relative inline-flex items-center rounded-r-md border border-transparent bg-indigo-600 px-2 py-0.5 text-sm font-medium text-slate-400 hover:bg-indigo-700 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500">
                      <span className="sr-only">Open options</span>
                      <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 z-10 mt-2 -mr-1 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className="py-1">
                          {[
                              { name: 'Return to assignee', onClick: () => {
                                  api.updateTaskStatus(db, params.taskID, 'reviewed').then(() => {
                                      setStatus('reviewed')
                                      // Show some toast or something.
                                  })
                              } }
                          ].map((item) => (
                            <Menu.Item key={item.name}>
                              {({ active }) => (
                                <a
                                  onClick={item.onClick}
                                  className={classNames(
                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                    'block px-4 py-2 text-sm cursor-pointer'
                                  )}
                                >
                                  {item.name}
                              </a>
                              )}
                            </Menu.Item>
                          ))}
                        </div>
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div> : null}
            </div>

          <div className="mt-5 sm:mt-6">
            <div className="sm:hidden">
              <label htmlFor="current-tab" className="sr-only">
                Select a tab
              </label>
              <select
                id="current-tab"
                name="current-tab"
                className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                defaultValue={currentTab ? currentTab.name : null}
              >
                {tabs.map((tab) => (
                  <option key={tab.name}>{tab.name}</option>
                ))}
              </select>
            </div>
            <div className="hidden sm:block">
              <nav className="-mb-px flex space-x-8">
                {tabs.map((tab) => (
                  <Link
                    key={tab.name}
                    to={tab.href}
                    className={classNames(
                      tab.current
                        ? 'border-indigo-500 text-indigo-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                      'whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm'
                    )}
                    aria-current={tab.current ? 'page' : undefined}
                  >
                    {tab.name}
                  </Link>
                ))}
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>

    <main>
      <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
        <Outlet context={[task, saving, setSaving, isAssignee, status]} />
      </div>
    </main>



    </div>
}


const getInitialTaskBodyFileData = (task) => {
    var fname, bodyState = {}
    for (fname in task.body.files){
        bodyState[fname] = typeof (task.body.files[fname].value) === 'object' ? (
            JSON.stringify(task.body.files[fname].value)
        ) : (task.body.files[fname].value || '')
    }

    return bodyState
}


export const Work = () => {
    const [task, saving, setSaving, isAssignee, status] = useOutletContext()
    const params = useParams()
    const [app, db] = useContext(FirebaseContext)

    var markSetupComplete = () => {
        api.updateSetup(db, params.taskID, true)
    }

    if (task.kind === 'structure-body-and-menu'){
        return <CodeEditor task={task} saving={saving}
            setSaving={setSaving} isAllowedToEdit={isAssignee/* && (status !== 'complete')*/}
            initialBody={getInitialTaskBodyFileData(task)}
            save={(fileName, body) => {
                api.updateTaskFile(db, params.taskID, fileName, body[fileName]).then(() => {
                    setSaving(false)
                })
            }}
            fileNames={Object.keys(task.body.files).sort()}
            schemas={function(){
                var fname, schemas = {}
                for (fname in task.body.files){
                    schemas[fname] = task.body.files[fname].schema
                }
                return schemas
            }()}
            markSetupComplete={markSetupComplete}
        />

    } else if (task.kind === 'select-and-rename-images'){
        return <ImageSelectorRenamer task={task} saving={saving}
            setSaving={setSaving} markSetupComplete={markSetupComplete} />

    } else if (task.kind === 'extract-attachments'){
        return <AttachmentsExtracter task={task} saving={saving}
            setSaving={setSaving} />

    } else if (task.kind === 'make-slides'){
        return <Slides task={task} saving={saving}
            setSaving={setSaving}
            isAllowedToEdit={isAssignee}
            initialBody={task.body.slides}
            // initialBody={JSON.stringify([
            //     { key: 0, content: [
            //         {
            //             key: 'text0',
            //             kind: 'text',
            //             text: 'Centimeter cubes as length units',
            //             formatting: {
            //                 level: 'title',
            //
            //                 position: { top: '70px', left: '100px' },
            //
            //                 color: '#fff',
            //                 size: 40, lineHeight: 48, textAlign: 'center',
            //                 width: 400, fontFamily: 'Shrikhand'
            //             },
            //         }
            //     ], background: {
            //         preset: 'flyingCubes'
            //     }},
            //     { key: 1, },
            //     { key: 2, content: [
            //         {
            //             key: 3,
            //             kind: 'slate',
            //             body: {
            //                 options: { template: 'die', number: 6 }
            //             },
            //
            //             formatting: {
            //                 width: 150,
            //                 height: 150,
            //                 position: { top: '120px', left: '225px' }
            //             }
            //         }
            //     ] },
            // ]
            // )}
            save={body => {
                api.updateTaskBody(db, params.taskID, 'slides', body).then(() => {
                    setSaving(false)
                })
            }}
        />
    }

    return null
}


const DropboxLoginButton = forwardRef((props, ref) => {
    return <div className="mt-8 text-center">
        <button
          type="button"
          className="rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          <a ref={ref}>Login with Dropbox</a>
        </button>
    </div>
})


function refreshDropboxTokenAndCall(user, setUser, dbx, callback){
    dbx.auth.refreshAccessToken().then(() => {
        var newAccessToken = dbx.auth.getAccessToken()
        setUser({ ...user, dropboxToken: { ...user.dropboxToken, access_token: newAccessToken } })
        callback(newAccessToken)
   })
}


function fetchWithDropbox(path, responseCallback, setInitializing, user, setUser){
    setInitializing(true)

    var fetchFn = (accessToken) => {
        fetch(path + `&dropbox_access_token=${accessToken || user.dropboxToken.access_token}`).then(response => {
            if (response.status === 403){
                var dbx = new Dropbox({
                     clientId: DROPBOX_CLIENT_ID,
                     accessToken: user.dropboxToken.access_token,
                     refreshToken: user.dropboxToken.refresh_token
                 })

                 refreshDropboxTokenAndCall(user, setUser, dbx, fetchFn)
            } else {
                return response.json()
            }
        })
        .then(response => {
            if (response){
                responseCallback(response)
            }
        })
    }

    fetchFn()
}


let codeAutosaveTimeout

const CodeEditor = ({ task, saving, setSaving, isAllowedToEdit, save, markSetupComplete, fileNames, initialBody, schemas }) => {
    const [fileName, setFileName] = useState(fileNames[0])
    const [informedChangesNotSaved, setInformedChangesNotSaved] = useState(false)
    const [user, setUser] = useContext(UserContext)

    const bodyRef = useRef()
    const params = useParams()
    const [app, db] = useContext(FirebaseContext)
    const editorRef = useRef()
    const dropboxLogin = useRef()

    const tabs = fileNames.map((file, i) => (
        { name: file, current: fileName === file }) ),
        currentTab = tabs.find((tab) => tab.current)

    const [body, setBody] = useState(initialBody)

    const [codeMode, setCodeMode] = useState(false),
        schema = schemas[fileName]
    const ajv = new Ajv({ allErrors: true, verbose: true })

    const [initializing, setInitializing] = useState(false)

    useEffect(() => {
        // If the activities and menu bodies are empty AND there is no 'setup'
        // on the body, and there is a source path and publisher,
        // fetch and save the initial body.
        var shouldInitializeByExtracting = !task.body.files['activities.json']?.value && (
            !task.body.files['menu.json']?.value && !task.body.setup) && (
            task.body.source?.path && task.body.source?.publisher)

        if (shouldInitializeByExtracting){
            var serviceOrigin = window.location.origin.indexOf('localhost') === -1 ? (
                'https://extract-docx-for-hub-xxxktuqbja-uc.a.run.app') : 'http://127.0.0.1:5001/extracter-1ed4e/us-central1/extract_docx_for_hub/'

            var path = `${serviceOrigin}?publisher=${
                task.body.source.publisher}&docx_path=${task.body.source.path}`

            if (!user?.dropboxToken){
                setInitializing('dropbox')

                setTimeout(() => {
                    setupLoginToDropboxButton(dropboxLogin)
                }, 1000)

            } else if (typeof(window) !== undefined) {
                fetchWithDropbox(path, response => {
                    // Set body values, and setup value.
                    save('activities.json', { 'activities.json': JSON.stringify(response.activities) })
                    save('menu.json', { 'menu.json': JSON.stringify(response.menu) })

                    setBody({
                        ...body,
                        'activities.json': JSON.stringify(response.activities),
                        'menu.json': JSON.stringify(response.menu)
                    })

                    markSetupComplete()

                    setInitializing(false)
                    setTimeout(() => {
                        editorRef.current.jsonEditor.set(response.activities)
                    }, 500)

                }, setInitializing, user, setUser)
            }
        }
    }, [])

    useEffect(() => {
        if (isAllowedToEdit && typeof(body[fileName]) === 'string' && bodyRef.current !== body[fileName]){
            clearTimeout(codeAutosaveTimeout)
            setSaving(true)
            codeAutosaveTimeout = setTimeout(function(){
                save(fileName, body)

                // Persist this change.
                clearTimeout(codeAutosaveTimeout)
            }.bind(this), 5000);
        } else if (!isAllowedToEdit && !informedChangesNotSaved) {
            setTimeout(() => {
                alert('Your changes are not saved because you are no longer assigned this task.')
                setInformedChangesNotSaved(true)
            }, 3000)
        }
        bodyRef.current = body[fileName]
    }, [body])

    useEffect(() => {
        if (codeMode && body[fileName]){
            setTimeout(() => {
                editorRef.current.jsonEditor.setText(body[fileName])
            })
        }
    }, [fileName, codeMode])


    var jsonBody = null
    if (body[fileName]){
        try {
            jsonBody = JSON.parse(body[fileName])
        } catch (e) {}
    }

    return initializing ? (initializing === 'dropbox' ? <DropboxLoginButton ref={dropboxLogin} /> : <PageLoading />) : <div className={WHITE_BG_TAB_BODY_CLASSES}>
        <div className="sm:flex sm:items-center">
            <div className="mb-4 sm:flex-auto">
                <Tabs tabs={tabs} onTabClick={function(){
                    if (isAllowedToEdit){
                        save(fileName, body)
                    }

                    setFileName(this.name)
                    clearTimeout(codeAutosaveTimeout)

                    bodyRef.current = body[this.name]
                }} />
            </div>

            <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">

                <Switch.Group as="div" className="flex items-center">
                  <Switch
                    checked={codeMode}
                    onChange={setCodeMode}
                    className={classNames(
                      codeMode ? 'bg-indigo-600' : 'bg-gray-200',
                      'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'
                    )}
                  >
                    <span
                      aria-hidden="true"
                      className={classNames(
                        codeMode ? 'translate-x-5' : 'translate-x-0',
                        'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                      )}
                    />
                  </Switch>
                  <Switch.Label as="span" className="ml-3">
                    <span className="text-sm font-medium text-gray-900">Code</span>
                  </Switch.Label>
                </Switch.Group>
            </div>
        </div>

        {codeMode ? <Editor
            key={currentTab.name + `-code`}
            value={null}
            onChangeText={(string) => setBody({...body, [fileName]: string}) }
            ace={ace}
            ajv={ajv}
            ref={editorRef}
            mode='code'
            schema={fullSchemas[schemas[currentTab.name]]}
            theme="ace/theme/github"
            htmlElementProps={{ style: { height: '500px' }}}
        /> : <Editor
            key={currentTab.name + `-tree`}
            value={jsonBody}
            ref={editorRef}
            onChangeText={(string) => setBody({...body, [fileName]: string}) }
            // ajv={ajv}
            // schema={fullSchemas[schemas[currentTab.name]]}
            htmlElementProps={{ style: { height: '500px' }}}
        />}

        <div className="mt-4 sm:flex sm:items-center">
            <div className="sm:flex-auto"></div>

            <div className="sm:mt-0 sm:ml-16 sm:flex-none">
                <button
                  type="button"
                  className={classNames("inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2", saving ? 'opacity-50' : 'hover:bg-gray-50')}
                  onClick={() => {
                      var origin
                      if (window.location.origin.indexOf('localhost') !== -1){
                          origin = 'http://localhost:8000'
                      } else {
                          origin = 'https://opencurriculum.org'
                      }
                      var preview = JSON.stringify({
                          activities: JSON.parse(body['activities.json']),
                          menu: JSON.parse(body['menu.json'])
                      })
                      window.open(`${origin}/2.0/lesson/none/lesson/rich/lesson?preview=${
                          encodeURIComponent(preview)}`, '_blank').focus()
                  }}
                >
                  Preview <ArrowTopRightOnSquareIcon className="ml-2 h-4 w-4" aria-hidden="true" />
              </button>
            </div>
        </div>

    </div>
}


const Tabs = ({ tabs, onTabClick }) => {
    const currentTab = tabs.find((tab) => tab.current)
    return <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
          defaultValue={currentTab.name}
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <nav className="flex space-x-4" aria-label="Tabs">
          {tabs.map((tab, i) => (
            <button
              key={tab.name}
              // href={tab.href}
              className={classNames(
                tab.current ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700',
                'px-3 py-2 font-medium text-sm rounded-md'
              )}
              aria-current={tab.current ? 'page' : undefined}
              onClick={onTabClick.bind(tab)}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>
    </div>

}


var imagePreviewFormats = ['jpg', 'jpeg', 'png', 'tiff', 'tif', 'gif', 'webp', 'ppm', 'bmp']


var client

async function initializeS3Client(callback){
    var idToken = await getIdToken(getAuth().currentUser)
    var idTokenResult = await getIdTokenResult(getAuth().currentUser)

    client = new S3Client({
        region: "us-east-1",
        credentials: fromCognitoIdentityPool({
            identityPoolId: 'us-west-1:9d54c30f-ecfb-4b26-8a93-53607b49699d',
            userIdentifier: idTokenResult.claims.firebase.identities['email'][0],
            identityId: idTokenResult.claims.firebase.identities['google.com'][0],
            logins: {
               'securetoken.google.com/explore-499e8': idToken,
           },
           clientConfig: { region: "us-west-1" }
        })
    })

    callback()
}


function setupLoginToDropboxButton(buttonRef){
    var dbx = new Dropbox({ clientId: DROPBOX_CLIENT_ID })
    var authUrl = dbx.auth.getAuthenticationUrl(
        `${window.location.origin}/dropbox-redirect-uri`, window.location.href, 'code', 'offline', undefined, undefined, true)
    .then((authUrl) => {
        window.sessionStorage.setItem('codeVerifier', dbx.auth.codeVerifier)
        buttonRef.current.href = authUrl
    })
}


const ImageSelectorRenamer = ({ task, saving, setSaving, markSetupComplete }) => {
    const [app, db] = useContext(FirebaseContext)
    const [user, setUser] = useContext(UserContext)
    const [sourceImages, setSourceImages] = useState([]/*tmpImageThumbnails.map(i => {
        return {
            id: i.metadata.id,
            name: i.metadata.name,
            size: i.metadata.size,
            thumbnail: i.thumbnail
        }
    })*/)
    const [destinationImages, setDestinationImages] = useState([])
    const [selected, setSelected] = useState()
    const [dbx, setDbx] = useState()
    const [fileToRename, setFileToRename] = useState()

    const dropboxLogin = useRef()
    const destinationParts = task.body.folders.destination.split('/'),
        destinationKeyPrefix = destinationParts.slice(1).join('/')

    const [initializing, setInitializing] = useState(false)


    var onSetupComplete = () => {
        var dbx = new Dropbox({
            clientId: DROPBOX_CLIENT_ID,
            accessToken: user.dropboxToken.access_token,
            refreshToken: user.dropboxToken.refresh_token
        })
        setDbx(dbx)

        async function listDropboxFolder(){
            dbx.filesListFolder({path: task.body.folders.source })
              .then(async function(response) {
                  var entriesToSeekThumbnailsFor = [], format
                  response.result.entries.forEach(entry => {
                      format = entry.name.split('.')[1]
                      if (imagePreviewFormats.indexOf(format) !== -1){
                          entriesToSeekThumbnailsFor.push({
                              "format": 'png',
                              "mode": "strict",
                              "path": entry.path_lower,
                              "size": "w64h64"
                          })
                      }
                  })

                  var duplicateInArray = entriesToSeekThumbnailsFor.slice(0), batches = []
                  while (duplicateInArray.length){
                      const batch = duplicateInArray.splice(0, 25)
                      var response = await dbx.filesGetThumbnailBatch({ entries: batch })
                        var newSourceImages = response.result.entries.map(i => {
                            return {
                                id: i.metadata.id,
                                name: i.metadata.name,
                                size: i.metadata.size,
                                thumbnail: i.thumbnail
                            }
                        })

                        batches = batches.concat(newSourceImages)
                    }

                    setSourceImages(batches)

                    initializeS3Client(() => {
                        const command = new ListObjectsCommand({
                          Bucket: destinationParts[0],
                          Prefix: destinationKeyPrefix + '/',
                        })

                        client.send(command).then(response => {
                            if (response.Contents){
                                setDestinationImages(response.Contents.map(i => {
                                    var name = i.Key.substring(destinationKeyPrefix.length + 1)
                                    return {
                                        id: i.ETag,
                                        name: name,
                                        size: i.Size,
                                        thumbnail: newSourceImages.find(si => si.name === name)?.thumbnail
                                    }
                                }))
                            }
                        })
                    })
              })
              .catch(function(error) {
                  if (error.error.error['.tag'] === 'expired_access_token'){
                      refreshDropboxTokenAndCall(user, setUser, dbx, listDropboxFolder)
                  }
              })
        }
        listDropboxFolder()
    }

    useEffect(() => {
        if (!user?.dropboxToken){
            setupLoginToDropboxButton(dropboxLogin)

        } else if (!task.body.setup && task.body.folders?.source && task.body.file){
            // If there is no 'setup' on the body, and there is a source path,
            // fetch and save the initial body.
            var serviceOrigin = window.location.origin.indexOf('localhost') === -1 ? (
                'https://extract-images-from-docx-for-hub-bjuo6e4taa-uc.a.run.app') : 'http://127.0.0.1:5001/explore-499e8/us-central1/extract_images_from_docx_for_hub'

            var path = `${serviceOrigin}?docxFilepath=${task.body.file}&dropboxImagesDirectory=${task.body.folders.source}`

            if (typeof(window) !== undefined){
                fetchWithDropbox(path, response => {
                    markSetupComplete()

                    onSetupComplete()

                    setInitializing(false)

                }, setInitializing, user, setUser)
            }

        } else if (task.body.setup && typeof(window) !== undefined){
            onSetupComplete()
        }
    }, [])

    var canMoveFromSourceToDestination = selected?.location === 'source',
        canMoveFromDestinationToSource = selected?.location === 'destination'

    return initializing ? <PageLoading /> : <>
        {user?.dropboxToken ? <div className="flex">
            <div className="w-2/5">
                <div className="mt-3 mb-6">
                    <h4 className="text-lg font-bold">All</h4>
                    <div className="text-xs text-gray-400">{task.body.folders.source}</div>
                </div>

                <ul role="list" className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
                  {sourceImages.map((image) => {
                      var imageInDestinationSet = destinationImages?.find(i => i.name === image.name)
                    return <li key={image.name} className={classNames("relative", imageInDestinationSet ? 'opacity-50' : '')}>
                      <div onClick={() => setSelected({ location: 'source', image })} className={classNames("group aspect-h-7 aspect-w-10 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-gray-200 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 border-2", (selected?.image.id === image.id) && selected?.location === 'source' ? 'border-indigo-500' : '')}>
                        <img src={`data:image/png;base64,${image.thumbnail}`} alt="" className={classNames("pointer-events-none object-cover", imageInDestinationSet ? '' : 'group-hover:opacity-75')} />
                        <button type="button" className={classNames("absolute inset-0 focus:outline-none")}>
                          <span className="sr-only">View details for {image.name}</span>
                        </button>
                      </div>
                      <p onClick={() => setFileToRename(image)} className="mt-2 block truncate text-sm font-medium text-gray-900 cursor-text hover:underline hover:text-indigo-500">{image.name}</p>
                      <p className="pointer-events-none block text-sm font-medium text-gray-500">{Math.round(image.size / 1024)} KB</p>
                    </li>
                 })}
                </ul>
            </div>
            <div className="w-1/5 flex justify-center items-center">
                <div>
                    <div>
                        <button
                          type="button"
                          className={classNames("inline-flex items-center rounded-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2", !canMoveFromSourceToDestination ? 'opacity-50' : 'hover:bg-gray-50')}
                          disabled={!canMoveFromSourceToDestination}
                          onClick={() => {
                              setSaving(true)
                              var downloadFromDropbox = () => {
                                  dbx.filesDownload({path: selected.image.id })
                                    .then(function(response) {
                                        const command = new PutObjectCommand({
                                          Bucket: destinationParts[0],
                                          Key: `${destinationKeyPrefix}/${selected.image.name}`,
                                          Body: response.result.fileBlob,
                                          ACL: 'public-read'
                                        })
                                        client.send(command).then(response => {
                                            // This code was written this way because there was
                                            // an expectation that the response would have something
                                            // more.
                                            setDestinationImages(destinationImages.concat([{
                                                id: selected.image.id,
                                                name: selected.image.name,
                                                size: selected.image.size,
                                                thumbnail: selected.image.thumbnail
                                            }]))
                                            setSaving(false)
                                            setSelected()
                                        })
                                    })
                                    .catch(function(error) {
                                      if (error.error['.tag'] === 'expired_access_token'){
                                          refreshDropboxTokenAndCall(user, setUser, dbx, downloadFromDropbox)
                                      }
                                    });
                              }

                              downloadFromDropbox()
                          }}
                        >
                          <ArrowRightIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                    </div>

                    <div className="mt-4">
                        <button
                          type="button"
                          className={classNames("inline-flex items-center rounded-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2", !canMoveFromDestinationToSource ? 'opacity-50' : 'hover:bg-gray-50')}
                          disabled={!canMoveFromDestinationToSource}
                          onClick={() => {
                              const command = new DeleteObjectCommand({
                                Bucket: destinationParts[0],
                                Key: `${destinationKeyPrefix}/${selected.image.name}`,
                              })

                              client.send(command).then(response => {
                                  var indexOfImageToRemove = destinationImages.findIndex(
                                      i => i.id === selected.image.id)
                                  setDestinationImages(update(destinationImages, { $splice: [[indexOfImageToRemove, 1]] }))
                                  setSelected()
                              })
                          }}
                        >
                          <ArrowLeftIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                    </div>

                </div>

            </div>
            {/*focus-within:ring-2 focus-within:ring-indigo-500*/}
            <div className="w-2/5">
                <div className="mt-3 mb-6">
                    <h4 className="text-lg font-bold">Selected</h4>
                    <div className="text-xs text-gray-400">{task.body.folders.destination}</div>
                </div>

                <ul role="list" className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
                  {destinationImages?.map((image) => (
                    <li key={image.name} className="relative">
                      <div onClick={() => setSelected({ location: 'destination', image })} className={classNames("group aspect-h-7 aspect-w-10 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-2 focus-within:ring-gray-200 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 border-2", (selected?.image.id === image.id) && selected?.location === 'destination' ? 'border-indigo-500' : '')}>
                        <img src={`data:image/png;base64,${image.thumbnail}`} alt="" className="pointer-events-none object-cover group-hover:opacity-75" />
                        <button type="button" className="absolute inset-0 focus:outline-none">
                          <span className="sr-only">View details for {image.name}</span>
                        </button>
                      </div>
                      <p className="pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900">{image.name}</p>
                      <p className="pointer-events-none block text-sm font-medium text-gray-500">{Math.round(image.size / 1024)} KB</p>
                    </li>
                  ))}
                </ul>

            </div>
        </div> : <DropboxLoginButton ref={dropboxLogin} />}

        <EditImageNameModal
            name={fileToRename?.name}
            open={fileToRename}
            setOpen={setFileToRename}
            update={name => {
                var originalName = fileToRename.name
                var renameInDropbox = () => {
                    dbx.filesMove({
                        from_path: `${task.body.folders.source}/${originalName}`,
                        to_path: `${task.body.folders.source}/${name}`
                    })
                      .then(function(response) {
                          setSourceImages(sourceImages => {
                              const sourceImageIndex = sourceImages.findIndex(
                                  i => i.name === originalName)

                              return update(
                                  sourceImages, { [sourceImageIndex]: { name: { $set: name } } } )
                          })
                      })
                      .catch(function(error) {
                        if (error.error.error['.tag'] === 'expired_access_token'){
                            refreshDropboxTokenAndCall(user, setUser, dbx, renameInDropbox)
                        }
                      });
                }
                renameInDropbox()

                // If it is in the destination, rename it there too.
                const destinationImageIndex = destinationImages.findIndex(
                    i => i.name === originalName)
                if (destinationImageIndex !== -1){
                    const command = new CopyObjectCommand({
                      Bucket: destinationParts[0],
                      CopySource: `${task.body.folders.destination}/${originalName}`,
                      Key: `${destinationKeyPrefix}/${name}`,
                    })
                    client.send(command).then(response => {
                        const command = new DeleteObjectCommand({
                          Bucket: destinationParts[0],
                          Key: `${destinationKeyPrefix}/${originalName}`,
                        })

                        client.send(command).then(response => {
                            setDestinationImages(update(
                                destinationImages, { [destinationImageIndex]: { name: { $set: name } } } ))
                        })
                    })
                }
            }}
        />

    </>
}


export const EditImageNameModal = ({ name, open, setOpen, update }) => {
    const cancelButtonRef = useRef(null)
    var nameRef = useRef()

    var nameWithoutExtension = name?.split('.')[0]

    useEffect(() => {
        if (nameRef.current){
            nameRef.current.value = nameWithoutExtension || ''
        }
    }, [name])

    return <Transition.Root show={!!open} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div>
                      <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                        Edit name
                      </Dialog.Title>

                      <div className='mt-2'>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                          Name
                        </label>
                        <div className="mt-1">
                          <input
                            defaultValue={nameWithoutExtension}
                            ref={nameRef}
                            type="text"
                            name="name"
                            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                            placeholder='File name'
                          />
                        </div>
                      </div>

                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={() => {
                        update(`${nameRef.current.value}.${name.split('.')[1]}`)
                        setOpen(false)
                    }}
                  >
                    Done
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={() => setOpen(false)}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
}


const blobToBase64 = blob => {
  const reader = new FileReader()
  reader.readAsDataURL(blob)
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result)
    }
  })
}


const AttachmentsExtracter = ({ task, saving, setSaving }) => {
    const [app, db] = useContext(FirebaseContext)
    const [user, setUser] = useContext(UserContext)
    const [sourceAttachments, setSourceAttachments] = useState([]/*tmpImageThumbnails.map(i => {
        return {
            id: i.metadata.id,
            name: i.metadata.name,
            size: i.metadata.size,
            thumbnail: i.thumbnail
        }
    })*/)
    const [destinationAttachments, setDestinationAttachments] = useState([])
    const [selected, setSelected] = useState()
    const [dbx, setDbx] = useState()
    const [fileToRename, setFileToRename] = useState()
    const [extractPagesOpen, setExtractPagesOpen] = useState()
    const [pdfDoc, setPdfDoc] = useState()

    const dropboxLogin = useRef()
    const destinationParts = task.body.folders.destination.split('/'),
        destinationKeyPrefix = destinationParts.slice(1).join('/')

    const fileNameParts = task.body.file.split('/'),
        fileName = fileNameParts[fileNameParts.length - 1]

    const [initializing, setInitializing] = useState(false)

    useEffect(() => {
        if (!user?.dropboxToken){
            setupLoginToDropboxButton(dropboxLogin)
        } else {

            var dbx = new Dropbox({
                clientId: DROPBOX_CLIENT_ID,
                accessToken: user.dropboxToken.access_token,
                refreshToken: user.dropboxToken.refresh_token
            })
            setDbx(dbx)

            async function downloadPDF(){
                dbx.filesDownload({path: task.body.file })
                  .then(async function(response) {
                    const fileAsArrayBuffer = await response.result.fileBlob.arrayBuffer()
                    const pdfDoc = await PDFDocument.load(fileAsArrayBuffer)
                    setPdfDoc(pdfDoc)
                })
                .catch(function(error) {
                  if (error.error['.tag'] === 'expired_access_token'){
                    refreshDropboxTokenAndCall(user, setUser, dbx, downloadPDF)
                  }
                });
            }

            async function listDropboxFolder(){
                dbx.filesListFolder({path: task.body.folders.source })
                  .then(async function(response) {
                      var entriesToSeekThumbnailsFor = [], format
                      response.result.entries.forEach(entry => {
                          entriesToSeekThumbnailsFor.push({
                              "format": 'png',
                              "mode": "strict",
                              "path": entry.path_lower,
                              "size": "w128h128"
                          })
                      })

                      var duplicateInArray = entriesToSeekThumbnailsFor.slice(0), batches = []
                      while (duplicateInArray.length){
                          const batch = duplicateInArray.splice(0, 25)
                          var response = await dbx.filesGetThumbnailBatch({ entries: batch })
                          var newSourceAttachments = response.result.entries.map(i => {
                                return {
                                    id: i.metadata.id,
                                    name: i.metadata.name,
                                    size: i.metadata.size,
                                    thumbnail: i.thumbnail,
                                    preview: `https://www.dropbox.com/work${i.metadata.path_display}`
                                }
                            })

                            batches = batches.concat(newSourceAttachments)
                        }

                        setSourceAttachments(batches)

                        initializeS3Client(() => {
                            const command = new ListObjectsCommand({
                              Bucket: destinationParts[0],
                              Prefix: destinationKeyPrefix,
                            })

                            client.send(command).then(response => {
                                if (response.Contents){
                                    setDestinationAttachments(response.Contents.filter(i => i.Key.endsWith('.pdf')).map(i => {
                                        var name = i.Key.substring(destinationKeyPrefix.length + 1)
                                        return {
                                            id: i.ETag,
                                            name: name,
                                            size: i.Size,
                                            thumbnail: newSourceAttachments.find(si => si.name === name)?.thumbnail
                                        }
                                    }))
                                }
                            })
                        })
                  })
                  .catch(function(error) {
                      if (error.error.error['.tag'] === 'expired_access_token'){
                          refreshDropboxTokenAndCall(user, setUser, dbx, listDropboxFolder)
                      }
                  })
            }

            // Download the PDF File
            downloadPDF()

            listDropboxFolder()
        }
    }, [])

    var canMoveFromSourceToDestination = selected?.location === 'source',
        canMoveFromDestinationToSource = selected?.location === 'destination'

    return initializing ? <PageLoading /> : <>
        {user?.dropboxToken ? <div className="flex">
            <div className="w-2/5">
                <div className="mt-3 mb-3">
                    <h4 className="text-lg font-bold">All</h4>
                </div>

                <div className="mb-3 col-span-1 flex rounded-md shadow-sm">
                  <div
                    className={classNames(
                      'bg-red-600 flex w-16 flex-shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-white'
                    )}
                  >
                    <DocumentOutlineIcon className="h-7 w-7" />
                  </div>
                  <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-b border-r border-t border-gray-200 bg-white">
                    <div className="flex-1 truncate px-4 py-2 text-sm">
                      <div className="font-medium text-gray-900 hover:text-gray-600">
                        {fileName}
                      </div>
                      <p className="text-gray-500">
                        <a href={`https://www.dropbox.com/work${task.body.file}`} target="_blank" className="truncate hover:underline">
                          Preview
                        </a>
                      </p>
                    </div>
                    <div className="flex-shrink-0 pr-2">
                        <button type="button"
                          className="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
                          onClick={() => setExtractPagesOpen(true)}
                        >
                          Extract...<span className="sr-only"></span>
                        </button>
                    </div>
                  </div>
              </div>

              <div className="my-4 text-xs text-gray-400">{task.body.folders.source}</div>

                <ul role="list" className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-4 lg:grid-cols-3 xl:gap-x-8">
                  {sourceAttachments.map((file) => {
                    var fileInDestinationSet = destinationAttachments?.find(i => i.name === file.name)
                    return <li key={file.name} className={classNames("relative", fileInDestinationSet ? 'opacity-50' : '')}>
                      <div onClick={() => setSelected({ location: 'source', file })} className={classNames("group aspect-h-7 aspect-w-10 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-gray-200 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 border-2", (selected?.file.id === file.id) && selected?.location === 'source' ? 'border-indigo-500' : '')}>
                        <img src={`data:image/png;base64,${file.thumbnail}`} alt="" className={classNames("pointer-events-none object-cover", fileInDestinationSet ? '' : 'group-hover:opacity-75')} />
                        <button type="button" className={classNames("absolute inset-0 focus:outline-none")}>
                          <span className="sr-only">View details for {file.name}</span>
                        </button>
                      </div>
                      <div className="flex mt-2 items-center">
                          <div className="flex-1 truncate">
                              <p onClick={() => setFileToRename(file)} className="block truncate text-sm font-medium text-gray-900 cursor-text hover:underline hover:text-indigo-500">{file.name}</p>
                              <p className="pointer-events-none block text-sm font-medium text-gray-500">{Math.round(file.size / 1024)} KB</p>
                              <p className="text-gray-500 text-xs"><a href={file.preview} target="_blank" className="truncate hover:underline">Preview</a></p>
                          </div>
                          <div className="flex-shrink-0 pr-2">
                              <Menu as="div" className="relative inline-block text-left">
                                <div>
                                  <Menu.Button className="-m-2 flex items-center rounded-full text-gray-400 hover:text-gray-600">
                                    <span className="sr-only">Open options</span>
                                    <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
                                  </Menu.Button>
                                </div>

                                <Transition
                                  as={Fragment}
                                  enter="transition ease-out duration-100"
                                  enterFrom="transform opacity-0 scale-95"
                                  enterTo="transform opacity-100 scale-100"
                                  leave="transition ease-in duration-75"
                                  leaveFrom="transform opacity-100 scale-100"
                                  leaveTo="transform opacity-0 scale-95"
                                >
                                  <Menu.Items className="absolute right-0 z-10 mt-2 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                    <div className="py-1">
                                      <Menu.Item>
                                        {({ active }) => (
                                          <a
                                            onClick={e => {
                                                var deleteInDropbox = () => {
                                                    dbx.filesDelete({ path: `${task.body.folders.source}/${file.name}` })
                                                      .then(function(response) {
                                                          setSourceAttachments(sourceAttachments => {
                                                              const sourceAttachmentIndex = sourceAttachments.findIndex(
                                                                  i => i.name === file.name)

                                                              return update(
                                                                  sourceAttachments, {$splice: [[sourceAttachmentIndex, 1]] })
                                                          })
                                                      })
                                                      .catch(function(error) {
                                                        if (error.error.error['.tag'] === 'expired_access_token'){
                                                            refreshDropboxTokenAndCall(user, setUser, dbx, deleteInDropbox)
                                                        }
                                                      });
                                                }
                                                deleteInDropbox()

                                                e.preventDefault()
                                            }}
                                            className={classNames(
                                              active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                              'block px-4 py-2 text-sm cursor-pointer'
                                            )}
                                          >
                                            Delete
                                          </a>
                                        )}
                                      </Menu.Item>
                                    </div>
                                  </Menu.Items>
                                </Transition>
                              </Menu>
                          </div>
                      </div>
                    </li>
                 })}
                </ul>
            </div>
            <div className="w-1/5 flex justify-center items-center">
                <div>
                    <div>
                        <button
                          type="button"
                          className={classNames("inline-flex items-center rounded-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2", !canMoveFromSourceToDestination ? 'opacity-50' : 'hover:bg-gray-50')}
                          disabled={!canMoveFromSourceToDestination}
                          onClick={() => {
                              setSaving(true)
                              var downloadFromDropbox = () => {
                                  dbx.filesDownload({path: selected.file.id })
                                    .then(function(response) {
                                        const command = new PutObjectCommand({
                                          Bucket: destinationParts[0],
                                          Key: `${destinationKeyPrefix}/${selected.file.name}`,
                                          Body: response.result.fileBlob,
                                          ACL: 'public-read'
                                        })
                                        client.send(command).then(response => {
                                            // This code was written this way because there was
                                            // an expectation that the response would have something
                                            // more.
                                            setDestinationAttachments(destinationAttachments.concat([{
                                                id: selected.file.id,
                                                name: selected.file.name,
                                                size: selected.file.size,
                                                thumbnail: selected.file.thumbnail
                                            }]))
                                            setSaving(false)
                                            setSelected()
                                        })
                                    })
                                    .catch(function(error) {
                                      if (error.error['.tag'] === 'expired_access_token'){
                                          refreshDropboxTokenAndCall(user, setUser, dbx, downloadFromDropbox)
                                      }
                                    });
                              }

                              downloadFromDropbox()
                          }}
                        >
                          <ArrowRightIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                    </div>

                    <div className="mt-4">
                        <button
                          type="button"
                          className={classNames("inline-flex items-center rounded-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2", !canMoveFromDestinationToSource ? 'opacity-50' : 'hover:bg-gray-50')}
                          disabled={!canMoveFromDestinationToSource}
                          onClick={() => {
                              const command = new DeleteObjectCommand({
                                Bucket: destinationParts[0],
                                Key: `${destinationKeyPrefix}/${selected.file.name}`,
                              })

                              client.send(command).then(response => {
                                  var indexOfImageToRemove = destinationAttachments.findIndex(
                                      i => i.id === selected.file.id)
                                  setDestinationAttachments(update(destinationAttachments, { $splice: [[indexOfImageToRemove, 1]] }))
                                  setSelected()
                              })
                          }}
                        >
                          <ArrowLeftIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                    </div>
                </div>

            </div>

            <div className="w-2/5">
                <div className="mt-3 mb-6">
                    <h4 className="text-lg font-bold">Selected</h4>
                    <div className="text-xs text-gray-400">{task.body.folders.destination}</div>
                </div>

                <ul role="list" className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-4 lg:grid-cols-3 xl:gap-x-8">
                  {destinationAttachments?.map((file) => (
                    <li key={file.name} className="relative">
                      <div onClick={() => setSelected({ location: 'destination', file })} className={classNames("group aspect-h-7 aspect-w-10 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-2 focus-within:ring-gray-200 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 border-2", (selected?.file.id === file.id) && selected?.location === 'destination' ? 'border-indigo-500' : '')}>
                        <img src={`data:image/png;base64,${file.thumbnail}`} alt="" className="pointer-events-none object-cover group-hover:opacity-75" />
                        <button type="button" className="absolute inset-0 focus:outline-none">
                          <span className="sr-only">View details for {file.name}</span>
                        </button>
                      </div>
                      <p className="pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900">{file.name}</p>
                      <p className="pointer-events-none block text-sm font-medium text-gray-500">{Math.round(file.size / 1024)} KB</p>
                    </li>
                  ))}
                </ul>

            </div>
        </div> : <DropboxLoginButton ref={dropboxLogin} />}

        <EditImageNameModal
            name={fileToRename?.name}
            open={fileToRename}
            setOpen={setFileToRename}
            update={name => {
                var originalName = fileToRename.name
                var renameInDropbox = () => {
                    dbx.filesMove({
                        from_path: `${task.body.folders.source}/${originalName}`,
                        to_path: `${task.body.folders.source}/${name}`
                    })
                      .then(function(response) {
                          setSourceAttachments(sourceAttachments => {
                              const sourceAttachmentIndex = sourceAttachments.findIndex(
                                  i => i.name === originalName)

                              return update(
                                  sourceAttachments, { [sourceAttachmentIndex]: { name: { $set: name }, preview: { $set: `https://www.dropbox.com/work${task.body.folders.source}/${name}` } } } )
                          })
                      })
                      .catch(function(error) {
                        if (error.error.error['.tag'] === 'expired_access_token'){
                            refreshDropboxTokenAndCall(user, setUser, dbx, renameInDropbox)
                        }
                      });
                }
                renameInDropbox()

                // If it is in the destination, rename it there too.
                const destinationAttachmentIndex = destinationAttachments.findIndex(
                    i => i.name === originalName)
                if (destinationAttachmentIndex !== -1){
                    const command = new CopyObjectCommand({
                      Bucket: destinationParts[0],
                      CopySource: `${task.body.folders.destination}/${originalName}`,
                      Key: `${destinationKeyPrefix}/${name}`,
                    })
                    client.send(command).then(response => {
                        const command = new DeleteObjectCommand({
                          Bucket: destinationParts[0],
                          Key: `${destinationKeyPrefix}/${originalName}`,
                        })

                        client.send(command).then(response => {
                            setDestinationAttachments(update(
                                destinationAttachments, { [destinationAttachmentIndex]: { name: { $set: name } } } ))
                        })
                    })
                }
            }}
        />

        <ExtractPDFModal
            open={extractPagesOpen}
            setOpen={setExtractPagesOpen}
            extract={async function(fromPage, toPage){
                const newDocument = await PDFDocument.create()
                const newPages = await newDocument.copyPages(
                    pdfDoc, new Array((toPage) - (fromPage - 1)).fill(0
                ).map((empty, i) => fromPage - 1 + i))

                for (const page of newPages) {
                  newDocument.addPage(page)
                }
                const newDocumentBytes = await newDocument.save()

                let newDocumentName = 'New file', hasConflict = true, index = 0
                while (hasConflict){
                    index += 1
                    hasConflict = sourceAttachments.find(sourceAttachment => (
                        sourceAttachment.name === `${newDocumentName} ${index}.pdf`
                    ))
                }

                var uploadToDropbox = () => {
                    dbx.filesUpload({
                        path: `${task.body.folders.source}/${newDocumentName} ${index}.pdf`,
                        contents: newDocumentBytes
                    }).then(function(response) {

                        dbx.filesGetThumbnail({
                          "format": 'png',
                          "mode": "strict",
                          "path": response.result.path_lower,
                          "size": "w128h128"
                      }).then(async function(response) {
                            var thumbnail = await blobToBase64(response.result.fileBlob)

                            setSourceAttachments(sourceAttachments => {
                                return sourceAttachments.concat([{
                                    id: response.result.id,
                                    name: response.result.name,
                                    size: response.result.size,
                                    thumbnail: thumbnail.substring(thumbnail.indexOf(',') + 1),
                                    preview: `https://www.dropbox.com/work${response.result.path_display}`
                                }])
                            })
                        })

                    }).catch(function(error) {
                      if (error.error.error['.tag'] === 'expired_access_token'){
                          refreshDropboxTokenAndCall(user, setUser, dbx, uploadToDropbox)
                      }
                    });
                }

                uploadToDropbox()
            }}
        />
    </>
}

let slidesAutosaveTimeout
const Slides = ({ task, saving, setSaving, initialBody, save, isAllowedToEdit }) => {
    const [app, db] = useContext(FirebaseContext)
    const [user, setUser] = useContext(UserContext)
    const [body, setBody] = useState(initialBody ? List(JSON.parse(initialBody)) : List())
    const [informedChangesNotSaved, setInformedChangesNotSaved] = useState(false)

    return <SlidesEditor body={body} save={newBody => {
        if (isAllowedToEdit){
            clearTimeout(slidesAutosaveTimeout)
            setSaving(true)
            slidesAutosaveTimeout = setTimeout(function(){
                save(JSON.stringify(newBody.toJS()))

                // Persist this change.
                clearTimeout(slidesAutosaveTimeout)
            }.bind(this), 5000);
        } else if (!isAllowedToEdit && !informedChangesNotSaved) {
            setTimeout(() => {
                alert('Your changes are not saved because you are no longer assigned this task.')
                setInformedChangesNotSaved(true)
            }, 3000)
        }
    }} />
}


export const ExtractPDFModal = ({ open, setOpen, extract }) => {
    const cancelButtonRef = useRef(null)
    const openRef = useRef()

    var fromPageRef = useRef()
    var toPageRef = useRef()

    useEffect(() => {
        if (open && fromPageRef.current && toPageRef.current && (!openRef.current || (openRef.current !== open))){
            fromPageRef.current.value = ''
            toPageRef.current.value = ''

            openRef.current = open
        }
    }, [open])

    return <Transition.Root show={!!open} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div>
                      <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                        Extract pages
                      </Dialog.Title>

                      <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <div className="sm:col-span-3">
                          <label htmlFor="from-page-number" className="block text-sm font-medium leading-6 text-gray-900">
                            From page number
                          </label>
                          <div className="mt-2">
                            <input
                              ref={fromPageRef}
                              type="text"
                              name="from-page-number"
                              id="from-page-number"
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            />
                          </div>
                        </div>

                        <div className="sm:col-span-3">
                          <label htmlFor="to-page-number" className="block text-sm font-medium leading-6 text-gray-900">
                            To page number
                          </label>
                          <div className="mt-2">
                            <input
                              ref={toPageRef}
                              type="text"
                              name="to-page-number"
                              id="to-page-number"
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            />
                          </div>
                        </div>
                      </div>

                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={() => {
                        extract(fromPageRef.current.value, toPageRef.current.value)
                        setOpen(false)
                    }}
                  >
                    Done
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={() => setOpen(false)}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
}


export const Instructions = () => {
    const [task] = useOutletContext()
    return <div className={WHITE_BG_TAB_BODY_CLASSES}>
        <Markdown options={{ forceBlock: true }}>{task.body.instructions || instructions[task.kind]}</Markdown>
    </div>
}


function getFiletypeFromSource(url){
    var parser = document.createElement('a');
    parser.href = url;

    if (parser.hostname.indexOf('youtube') !== -1 || parser.hostname.indexOf('vimeo') !== -1)
        return 'video';

    else if (parser.hostname.indexOf('docs.google.com') !== -1)
        return 'drive';

    var extensionIndex = url.lastIndexOf('.');

    if (extensionIndex === -1)
        return 'upload';

    var extension = url.substring(extensionIndex);

    var extensions = {
        document: [".doc", ".docx", ".rtf", ".odt"],
        presentation: [".key", ".keynote", ".ppt", ".pptx", ".odp"],
        spreadsheet: [".xls", ".xlsx", ".ods", ".csv"],
        pdf: [".pdf"],
        image: [".jpg", ".jpeg", ".png", ".bmp", ".eps", ".ps", ".gif", ".tiff", ".svg"],
    }

    if (extensions.document.indexOf(extension) !== -1)
        return 'document';

    else if (extensions.pdf.indexOf(extension) !== -1)
        return 'pdf';

    else if (extensions.presentation.indexOf(extension) !== -1)
        return 'presentation';

    else if (extensions.spreadsheet.indexOf(extension) !== -1)
        return 'spreadsheet';

    else if (extensions.image.indexOf(extension) !== -1)
        return 'image';

    else
        return 'upload';
}


const extensionIconMap = {
    video: <VideoCameraIcon className="h-12 w-12" aria-hidden="true" />,
    drive: <FolderIcon className="h-12 w-12" aria-hidden="true" />,
    document: <DocumentIcon className="h-12 w-12" aria-hidden="true" />,
    pdf: <DocumentIcon className="h-12 w-12" aria-hidden="true" />,
    presentation: <PresentationChartBarIcon className="h-12 w-12" aria-hidden="true" />,
    spreadsheet: <TableCellsIcon className="h-12 w-12" aria-hidden="true" />,
    image: <PhotoIcon className="h-12 w-12" aria-hidden="true" />,
    upload: <GlobeAltIcon className="h-12 w-12" aria-hidden="true" />
}


export const Materials = function(){
    const [task] = useOutletContext()
    return <div className={WHITE_BG_TAB_BODY_CLASSES}>
        <ul role="list" className="divide-y divide-gray-200">{task.body.materials.map((m, i) => {
            var filetype = getFiletypeFromSource(m.url)
            return <li key={i}>
                  <a href={m.url} className="block hover:bg-gray-50" rel="noreferrer" target="_blank">
                    <div className="flex items-center px-4 py-4 sm:px-6">
                      <div className="flex min-w-0 flex-1 items-center">
                        <div className="flex-shrink-0">
                            {extensionIconMap[filetype]}
                        </div>
                        <div className="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                          <div>
                            <p className="truncate text-sm font-medium text-indigo-600">{m.name}</p>
                            <p className="mt-2 flex items-center text-sm text-gray-500">

                              <span className="truncate">{filetype.toUpperCase()}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <ArrowUpRightIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                      </div>
                    </div>
                </a>
            </li>})
        }</ul>
    </div>
}


export const Comments = ({ parentKind, parentID }) => {
    const [user, setUser] = useContext(UserContext);
    const params = useParams()
    const [comments, setComments] = useState()
    const [app, db] = useContext(FirebaseContext)
    const commentRef = useRef()
    const [task] = useOutletContext()
    let location = useLocation()

    useEffect(() => {
        if (!parentKind){
            api.getComments(db, 'tasks', params.taskID).then((comments) => {
                setComments(comments)
            })
        } else {
            api.getComments(db, parentKind, parentID).then((comments) => {
                setComments(comments)
            })
        }
    }, [])

    return <div className={WHITE_BG_TAB_BODY_CLASSES}>
        <div className={classNames("mx-auto py-2 px-4 sm:px-0 md:py-2", parentKind ? null : "max-w-xl")}>
            <ul role="list" className="divide-y divide-gray-200">
                {comments?.sort((a, b) => a.timestamp - b.timestamp).map(comment => <li
                      key={comment.id}
                      className="relative bg-white py-5"
                    >

                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <img
                        className="inline-block h-10 w-10 rounded-full"
                        src={comment.user.photoURL} referrerPolicy="no-referrer"
                        alt=""
                      />
                    </div>
                    <div className="min-w-0 flex-1">
                        <p className="truncate text-sm">
                            <span className="text-gray-900 font-medium mr-2">{comment.user.firstName} {comment.user.lastName}</span>
                            <time dateTime={comment.timestamp.toDate()} className="whitespace-nowrap text-gray-500">{comment.timestamp.toDate().toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</time>
                        </p>
                        <div className="mt-1">
                            <p className="text-sm text-gray-600 line-clamp-2">{comment.body}</p>
                        </div>

                    </div>
                    <div className='flex flex-shrink-0 self-center'>
                        {comment.user.email === user.email ? <Menu as="div" className="relative inline-block text-left">
                          <div>
                            <Menu.Button className="-m-2 flex items-center rounded-full text-gray-400 hover:text-gray-600">
                              <span className="sr-only">Open options</span>
                              <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
                            </Menu.Button>
                          </div>

                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                              <div className="py-1">
                                <Menu.Item>
                                  {({ active }) => (
                                    <a
                                      onClick={e => {
                                          var indexOfComment = comments.findIndex(c => c.id === comment.id)
                                          setComments(update(comments, {$splice: [[indexOfComment, 1]] }))

                                          api.deleteComment(db, comment.id)

                                          e.preventDefault()
                                      }}
                                      className={classNames(
                                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                        'block px-4 py-2 text-sm'
                                      )}
                                    >
                                      Delete
                                    </a>
                                  )}
                                </Menu.Item>
                              </div>
                            </Menu.Items>
                          </Transition>
                      </Menu> : null}
                    </div>
                  </div>
                </li>
            )}

          </ul>


          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <img
                className="inline-block h-10 w-10 rounded-full"
                src={user.photoURL} referrerPolicy="no-referrer"
                alt=""
              />
            </div>
            <div className="min-w-0 flex-1">
              <form action="#" className="relative">
                <div className="overflow-hidden rounded-lg border border-gray-300 shadow-sm focus-within:border-indigo-500 focus-within:ring-1 focus-within:ring-indigo-500">
                  <label htmlFor="comment" className="sr-only">
                    Add your comment
                  </label>
                  <textarea
                    rows={parentKind ? 1 : 2}
                    ref={commentRef}
                    name="comment"
                    id="comment"
                    className="block w-full resize-none border-0 py-3 focus:ring-0 sm:text-sm"
                    placeholder="Add your comment..."
                    defaultValue={''}
                  />

                  {/* Spacer element to match the height of the toolbar */}
                  <div className="py-2" aria-hidden="true">
                    {/* Matches height of button in toolbar (1px border + 36px content height) */}
                    <div className="py-px">
                      <div className="h-9" />
                    </div>
                  </div>
                </div>

                <div className="absolute inset-x-0 bottom-0 flex justify-between py-2 pl-3 pr-2">
                  <div className="flex items-center space-x-5">
                  </div>
                  <div className="flex-shrink-0">
                    <button
                      type="submit"
                      onClick={e => {
                          var newCommentID = uuidv4().substring(0, 8)

                          setComments(update(comments, {$push: [{
                              id: newCommentID, body: commentRef.current.value, user,
                              timestamp: Timestamp.now()
                          }] }))

                          api.submitComment(
                              db, parentKind || 'tasks', parentID || params.taskID,
                              newCommentID, commentRef.current.value, user
                          )

                          if (!parentKind){
                              var notificationID = uuidv4().substring(0, 8)
                              api.notifications.add(
                                  db, notificationID, user.email === task.assignee.id ? task.assigner.id : task.assignee.id,
                                  `${user.firstName} ${user.lastName} commented on the task "${task.title}" for ${task.parentTitle}`, location.pathname,
                                  'user', user.email, 'comment', newCommentID, 'task', params.taskID
                              )
                          }

                          commentRef.current.value = ''

                          e.preventDefault()
                      }}
                      className="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      Post
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>


        </div>
    </div>
}


export const Review = () => {
    // Need to first figure out whether we need to show a "to review" screen,
    // or a reviewed screen.
    const [task, saving, setSaving, isAssignee] = useOutletContext()
    const params = useParams()
    const [app, db] = useContext(FirebaseContext)
    const [review, setReview] = useState()
    const [user, setUser] = useContext(UserContext);

    var body

    useEffect(() => {
            let ignore = false

            api.getReviewForTask(db, params.taskID).then((review) => {
                if (review){
                    setReview(review)
                } else {
                    if (!ignore && !isAssignee){
                        var newReviewID = uuidv4().substring(0, 8)
                        setReview({ id: newReviewID, timestamp: Timestamp.now(), reviewer: user })
                        api.addReviewForTask(db, params.taskID, newReviewID, user)
                    }
                }
            })
            return () => { ignore = true };
    }, [])

    if (!review)
        return <PageLoading />

    if (task.status === 'reviewed'){
        if (task.kind === 'structure-body-and-menu'){
            return <ReviewedFiles review={review} task={task} />
        }

    } else if (task.status === 'review'){
        if (task.kind === 'structure-body-and-menu')
            body = <CodeEditor task={task} saving={saving}
                setSaving={setSaving} isAllowedToEdit={true}
                initialBody={function(){
                    var initialBody = {...getInitialTaskBodyFileData(task)}

                    var fname
                    for (fname in initialBody){
                        if (review.body?.files && review.body?.files.hasOwnProperty(fname) && review.body?.files[fname].value)
                            initialBody[fname] = review.body.files[fname].value
                    }

                    return initialBody
                }()}
                save={(fileName, body) => {
                    api.updateReviewFile(db, review.id, fileName, body[fileName]).then(() => {
                        setSaving(false)
                    })
                }}
                fileNames={Object.keys(task.body.files).sort()}
                schemas={function(){
                    var fname, schemas = {}
                    for (fname in task.body.files){
                        schemas[fname] = task.body.files[fname].schema
                    }
                    return schemas
                }()}
            />
    }

    return <div className='Review'>
        {body}
        <div className="mt-2">
            <Comments parentKind='reviews' parentID={review.id} />
        </div>
    </div>
}


const ReviewedFiles = ({ review, task }) => {
    const fileNames = Object.keys(review.body.files).sort()
    const [fileName, setFileName] = useState(fileNames[0])

    return <div className='Review'>
        <Comments parentKind='reviews' parentID={review.id} />

        <div className="mt-4">
            {fileNames ? <Tabs
                tabs={fileNames.map((name, i) => ({
                    name, current: fileName === name
                }))}
                onTabClick={function(){
                    setFileName(this.name)
                }
            } /> : null}
        </div>

        <div className="mt-4">
            <div className="mb-8">
                <div className="font-medium my-4">Changes</div>
                <div className="rounded-b-lg shadow">
                    <ReactJsonViewCompare oldData={JSON.parse(task.body.files[fileName].value)} newData={JSON.parse(review.body.files[fileName].value)} />
                </div>
            </div>

            <div>
                <div className="font-medium my-4">Full review work</div>
                <div className={WHITE_BG_TAB_BODY_CLASSES}>
                    <pre className='text-wrap'>{JSON.stringify(JSON.parse(review.body.files[fileName].value), null, 2)}</pre>
                </div>
            </div>
        </div>
    </div>
}
